import { useQuery } from "@apollo/client";
import { TAXONOMY_CLIENT } from "../../../utils/consts";
import { CATEGORY_VENDOR_COUNT_QUERY } from "./queries/categoryVendorCountQuery";
import { NumberCard } from "../components/NumberCard";

export const VendorCountCard = (props: { leafCategoryIds: string[] }) => {
  const { data, loading } = useQuery(CATEGORY_VENDOR_COUNT_QUERY, {
    variables: {
      categoryIds: props.leafCategoryIds,
    },
    skip: props.leafCategoryIds.length === 0,
    context: {
      clientName: TAXONOMY_CLIENT,
    },
  });

  return (
    <NumberCard
      id="vendor-count"
      isLoading={loading}
      count={data?.vendor.count || 0}
      title="Number of Vendors"
    />
  );
};
